import { createContext } from 'react';

export type ScaleValue = '0.9' | '0.95' | '1' | '1.05' | '1.1';

export interface ScaleContextType {
  scale: ScaleValue;
  setScale: (scale: ScaleValue) => void;
}

export const ScaleContext = createContext<ScaleContextType | undefined>(
  undefined
);

